import enLang from './entries/en_US';
import esLang from './entries/es_ES';
import thaiLang from './entries/th-TH';
import roLang from './entries/ro_RO';
import hrLang from './entries/hr_HR';
import ptLang from './entries/pt_PT';
const AppLocale = {
  en: enLang,
  es: esLang,
  th: thaiLang,
  ro: roLang,
  hr: hrLang,
  pt: ptLang,
};

export default AppLocale;
